
export type MarkAllNotificationsAsReadBody = {
  recipientId: string;
};
